import React from 'react'
import { SelectAsyncCreatable } from '@ztechapps/webui.input'
import { ProductSelect } from './ProductSelect'
import type { ProductSelectProps } from '@ztechapps/webui.contract'

export const ProductSelectCreatable = (props: ProductSelectProps) => {
  return <ProductSelect {...props} As={SelectAsyncCreatable} />
}
